<template>
  <div class="activity-wrap" style="background:rgba(177, 12, 8, 1)">
    <app-header />
    <!-- <div class="banner">
      <img src="@/assets/images/activity/activity20231111/slogn.png" alt="" class="slogn">
      <p>活动时间：10月25日-11月15日</p>
      <div class="coupons">
        <a @click="goUrl(116)" class="coupon1">大智慧365</a>
        <a @click="goUrl(73)" class="coupon2">大智慧专业版</a>
      </div>
    </div> -->
    <!-- 倒计时悬浮框 -->
    <!-- <div class="side-bar" v-show="showSidebar">
      <strong class="left-num">{{leftDays}}</strong>
      <span class="side-close" @click="showSidebar=false">x</span>
    </div>
    <div class="wrap">
      <h3 class="mod-tit tit1">大智慧365</h3>
      <div class="mod mod1" @mouseover="mouseoverFun" @mouseout="initSwipeTab">
        <div class="mod-tabs">
          <span v-for="(tab,i) in tabs" :class="curTab==i?'actived':''" @click="curTab=i">{{tab}}</span>
        </div>
        <div class="mod-cont">
          <div class="tabs-cont" v-show="curTab==0">
            <h4 class="tabs-cont-head">千万股民口碑之选——千档行情、全息盘口，主力控盘区域一目了然</h4>
            <img src="@/assets/images/activity/activity20231111/img1.png" alt="" width="100%">
            <p>Level2超级盘口对于分析盘中买卖盘、盘后复盘有极其重要的作用。<br>千档盘口让你看到别人看不到的行情，一眼看穿主力大资金潜伏价位；<br>全息盘口完美展示个股每一笔的成交情况，是盘中跟踪、盘后复盘利器。</p>
          </div>
          <div class="tabs-cont" v-show="curTab==1">
            <h4 class="tabs-cont-head flex">
              <strong>L点：关注信号<br><em class="c-blue">D</em>点：风险信号</strong>
              <strong><em class="c-brown">B</em>点：反转信号<br><em class="c-green">S</em>点：避险信号</strong>
            </h4>
            <img src="@/assets/images/activity/activity20231111/img1_2.png" alt="" width="100%">
          </div>
          <div class="tabs-cont" v-show="curTab==2">
            <h4 class="tabs-cont-head">DDE当日资金流排序功能，助力投资者紧跟热钱的脚步</h4>
            <img src="@/assets/images/activity/activity20231111/img1_3.png" alt="" width="100%">
          </div>
        </div>
      </div>
      <h3 class="mod-tit tit2">大智慧365十二项尊贵特权</h3>
      <div class="mod mod2">
        <img src="@/assets/images/activity/activity20231111/img2.png" alt="" width="100%">
        <h5>—— 更多功能不断升级中 ——</h5>
      </div>
      <div class="mod-buy">
        <a @click="goUrl(116)" class="btn-buy btn1">低至1.6元/天 立即抢购</a>
      </div>
      <h3 class="mod-tit tit3">大智慧专业版</h3>
      <div class="mod mod3">
        <div class="mod-cont">
          <h6><strong>超赢实时监控</strong></h6>
          <p>主力大单、散户资金动向一目了然，一眼看穿股价涨跌背后的资金博弈</p>
          <img src="@/assets/images/activity/activity20231111/img3.gif" alt="" width="100%" style="margin-bottom:54px;">
          <h6><strong>龙头看盘</strong>日内打板利器</h6>
          <img src="@/assets/images/activity/activity20231111/img4.png" alt="" width="100%" style="margin-bottom:54px;">
          <h6><strong>私密投资策略</strong>海量专业数据支持，个性化编写属于自己的投资策略</h6>
          <img src="@/assets/images/activity/activity20231111/img5.png" alt="" width="100%">
        </div>
      </div>
      <dl class="mod-tips">
        <dt>关于大智慧「专业版」</dt>
        <dd>大智慧「专业版」是为专业投资型用户所研发的软件，除基本包含大智慧「365」全部功能外，还增加了<strong>“超赢实时监控”“机构去哪儿”“ACE量柱”“董秘爆料”“热点狙击”“竞价洞察”“主动资金”等十多项高端功能。</strong></dd>
        <dd>大智慧「专业版」提供全面的市场交易数据，可按照投资者的思路，对指标设计、公式选股、扩展数据进行深度个性化运用，建立个人专属的投资模型，决胜A股！</dd>
      </dl>
      <div class="mod-buy buy2">
        <a @click="goUrl(73)" class="btn-buy btn2">活动价2980元/2年 立即抢购</a>
      </div>
    </div> -->
    <div class="close_main" style="max-width: 1216px;margin:0 auto;background:rgba(177, 12, 8, 1)">
      <img style="width:100%;padding: 20px 0" :src="closeImg" alt="">
    </div>
    <div class="footer">
      <p class="wrap">风险提示：本产品不涉及投资咨询及投资顾问服务，所展示信息不构成投资建议；数据基于历史，不代表未来趋势；<br>所有工具都有局限性，适合不同情况下的市场，仅供参考，请理性投资，控制风险，投资有风险，入市需谨慎。</p>
    </div>
  </div>
</template>
<script>
import AppHeader from "@/components/common/AppHeader.vue";
export default {
  components: {
    AppHeader,
  },
  data () {
    return {
      token: '',
      curTab:0,
      tabs:['超级Level2','波段线','热钱追踪'],
      timer:'',
      leftDays:3,
      showSidebar:false,
      closeImg: require('@/assets/images/activity/activity20231111/close_img.jpg'),
    }
  },
  created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
  },
  mounted() {
    this.initSwipeTab()
    this.timeDown()
  },
  methods: {
    goUrl (key, month=24) {
      let routerDate;
      // if (this.token && key !== 4024) {
      //   routerDate = this.$router.resolve({name: 'ClientProduct', query: {token: this.token, pid: key, month: month}})
      // } else {
      //   routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: key,month: month}})
      // }
      routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: key,month: month}})
      let {href} = routerDate
      window.open(href, "_blank")
    },
    initSwipeTab(){
      var ts = this
      ts.timer = setInterval(function(){
        if(ts.curTab>=2){
          ts.curTab=-1
        }
        ts.curTab++
      },5000)
    },
    mouseoverFun(){
      var ts = this
      clearInterval(ts.timer)
    },
    timeDown(){
      var ts = this
      var xhr = new XMLHttpRequest();
      //使用HEAD获取当前页面的响应头
      xhr.open('HEAD', window.location.href);
      xhr.onreadystatechange = function () {
        //等待响应完成
        if (this.readyState === this.DONE) {
          //响应完毕后修改时区为东八区为准
          var serverTime = xhr.getResponseHeader('Date');
          var offset = new Date().getTimezoneOffset() / 60;
          //获取当前服务器时间
          var chinaTime = new Date(new Date(serverTime).getTime() + offset * 60 * 60 * 1000 + 8 * 60 * 60 * 1000)

          var now = chinaTime
          var end = new Date("2023/11/16")
          var lefttime = end.getTime() - now.getTime()  //距离结束时间的毫秒数
          ts.leftDays = Math.ceil(lefttime/(1000*60*60*24)) //计算天数
          console.log(now,ts.leftDays)
          if(ts.leftDays>0&&ts.leftDays<=3){
            ts.showSidebar = true
          }else{
            ts.showSidebar = false
          }
        }
      }
      xhr.send()
    },

  }
}
</script>
<style lang="scss" scoped>
.activity-wrap{
  background:#80081b;background-image:-webkit-linear-gradient(left,#80081b 0%, #c40927 50%,#80081b 100%);overflow:hidden;
  .wrap{max-width: 1216px;margin:0 auto;width:auto;}
  .flex { display: -webkit-flex; display: -ms-flexbox; display: flex; -webkit-flex-wrap: nowrap; -ms-flex-wrap: nowrap; flex-wrap: nowrap; }
  .flex > * { -webkit-flex: 1; -ms-flex: 1; flex: 1; }
  .fl{float:left}
  .fr{float:right;}
  .banner{background:url('../../assets/images/activity/activity20231111/banner.jpg') no-repeat center top;position:relative;height:892px;text-align:center;padding-top:104px;overflow:hidden;}
  .slogn{width:915px;margin:0 auto 12px;}
  .banner p{font-size: 32px;color: #fff;}
  .coupons{}
  .coupons a{position:absolute;text-indent:-999px;overflow:hidden;width:540px;height:210px;left:50%;top:530px;}
  .coupons a.coupon1{background:url('../../assets/images/activity/activity20231111/coupon1.png') no-repeat 0 0;margin-left:-554px;}
  .coupons a.coupon2{background:url('../../assets/images/activity/activity20231111/coupon2.png') no-repeat 0 0;margin-left:7px;}
  .mod-tit{text-indent:-999px;overflow:hidden;height:230px;background:url('../../assets/images/activity/activity20231111/title1.png') no-repeat center center;}
  .mod-tit.tit1{margin-bottom:60px;}
  .mod-tit.tit2{background-image:url('../../assets/images/activity/activity20231111/title2.png');}
  .mod-tit.tit3{background-image:url('../../assets/images/activity/activity20231111/title3.png');}
  .mod{background:#d41026;border-radius:20px;box-shadow: 0 0 10px #910413;padding: 26px 36px;position:relative;}
  .mod1:before,.mod2:before{content:'';position:absolute;background:url('../../assets/images/activity/activity20231111/icon-coin.png') no-repeat 0 0;width:206px;height:209px;}
  .mod1:before{right:-200px;top:-200px;-webkit-transform:scaleX(-1);-ms-transform:scaleX(-1);transform:scaleX(-1);}
  .mod2:before{left:-200px;top:-160px;}

  .mod3:before,.mod3:after{content:'';position:absolute;background:url('../../assets/images/activity/activity20231111/icon-coin2.png') no-repeat 0 0;width:151px;height:128px;}
  .mod3:before{left:-200px;bottom:700px;}
  .mod3:after{right:-200px;top:400px;width:112px;-webkit-background-size: 100% auto;-ms-background-size: 100% auto;background-size: 100% auto;}
  .mod h5{text-align:center;font-size:52px;color: #fff;font-style:italic;margin-top:20px;line-height:2;}
  .mod-tabs{position:absolute;left:0;top:-56px;right:0;text-align:center;}
  .mod-tabs span{display:inline-block;line-height:80px;text-align:center;font-size:40px;color: #fff;border-radius:10px 10px 0 0;background-image:-webkit-linear-gradient(top,#ff5052 0%,#e6051f 100%);background-image:linear-gradient(180deg,#ff5052 0%,#e6051f 100%);width: 26%;margin:0 13px;border:2px solid #fef9ed;cursor:pointer;}
  .mod-tabs span.actived{color: #d00202;background-image:-webkit-linear-gradient(top,#fff58e 0%,#e8d139 100%);background-image:linear-gradient(180deg,#fff58e 0%,#e8d139 100%);}
  .mod-cont{background:#fef9ed;border-radius:16px;padding: 26px;overflow:hidden;}
  .mod-cont p{font-size: 28px;color: #404040;text-align:center;line-height:1.7;margin-top:15px;}
  .tabs-cont-head{margin:-26px -26px 20px;background:#f7e7cb;font-size: 34px;color: #552e1f;text-align:center;padding:25px 15px;}
  .tabs-cont-head strong{line-height:2.2;}
  .tabs-cont-head strong:first-child{padding-left:180px;}
  .tabs-cont-head strong:last-child{padding-right:180px;}
  .tabs-cont-head strong em{color: #000;font-weight: bold;}
  .tabs-cont-head strong em.c-blue{color: #54ffff;}
  .tabs-cont-head strong em.c-brown{color: #eb9500;}
  .tabs-cont-head strong em.c-green{color: #45ff37;}
  .mod-buy{background:url('../../assets/images/activity/activity20231111/icon-coin3.png') no-repeat 0 0;margin-top:60px;}
  .mod-buy.buy2{background-position:100% 0;padding-bottom:30px;}
  .btn-buy{display:block;text-indent:-999px;overflow:hidden;height:182px;margin:0 auto;animation:zoom 2s linear infinite;}
  @keyframes zoom{
    0%{transform:scale(1)}
    10%{transform:scale(0.85)}
    20%{transform:scale(1.05)}
    30%{transform:scale(0.9)}
    40%{transform:scale(1)}
    100%{transform:scale(1)}
  }
  .btn-buy.btn1{background:url('../../assets/images/activity/activity20231111/btn1.png') no-repeat 0 0;width: 907px;}
  .btn-buy.btn2{background:url('../../assets/images/activity/activity20231111/btn2.png') no-repeat 0 0;width: 946px;}
  .mod-tips{margin:40px 50px;line-height:1.7;}
  .mod-tips dt{font-size:28px;color: #fff;font-weight:bold;margin-bottom:15px;}
  .mod-tips dd{font-size:20px;color:#f2b3b8;margin-bottom:10px;}
  .mod-tips dd strong{color: #fff;font-weight:bold;}
  .footer{background:#3f3f3f;text-align:center;padding: 20px 0 30px;}
  .footer p{font-size: 14px;color:#fff;opacity:0.3;line-height:2;}
  .mod-cont h6{margin:0 0 15px -26px;color:#555;font-size:28px;overflow:hidden;line-height:70px;}
  .mod-cont h6 strong{float:left;padding:0 30px;font-size:46px;color: #9d7540;position:relative;z-index:1;margin-right:20px;}
  .mod-cont h6 strong:after{content:'';position:absolute;left:-30px;right:0;top:0;bottom:0;background-image:linear-gradient(180deg,#ffe4c3 0%,#ffc06b 100%);background-image:-webkit-linear-gradient(top,#ffe4c3 0%,#ffc06b 100%);z-index:-1;transform:skew(25deg);}
  .side-bar{
    position:fixed;
    z-index:10;
    right:10px;
    top:50%;
    background:url('../../assets/images/activity/activity20231111/sider.png') no-repeat 0 0;
    width:275px;
    height:293px;
    margin-top:-80px;
    .left-num{
      position:absolute;
      font-size:54px;color:#fff;font-weight:bold;
      left:140px;top:166px;width:50px;text-align:center;
    }
    .side-close{
      position:absolute;left:50%;bottom:-35px;width:26px;height:26px;
      background:#fff;border-radius:50%;text-indent:-999px;overflow:hidden;
      transform:rotate(45deg);
      cursor:pointer;
      &:before,&:after{
        content:'';
        position:absolute;
        left:50%;top:50%;
        background:#5d0f15;
        transform:translate(-50%,-50%);
        border-radius:2px;
      }
      &:before{width:50%;height:2px;}
      &:after{width:2px;height:50%;}
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/activity/activity20231111.vue